import PropTypes from "prop-types";
import InputText from "core/inputs/input-text/InputText";
import InputTextArea from "core/inputs/input-text-area/InputTextArea";
import { Controller } from "utils/Controller";
import {
  DELIVERY_NOTE_FORM_LABELS,
  DELIVERY_NOTE_FORM_PLACEHOLDERS,
} from "constants/forms";

const PartyTextField = ({ control, register, prefix, field, rows }) => {
  const name = `${prefix}_${field}`;
  const id = `delivery-note-${prefix}-${field}`;
  const label = DELIVERY_NOTE_FORM_LABELS[field];
  const placeholder = DELIVERY_NOTE_FORM_PLACEHOLDERS[field];

  return (
    <Controller
      control={control}
      register={register}
      name={name}
      render={(props) =>
        rows ? (
          <InputTextArea
            id={id}
            label={label}
            placeholder={placeholder}
            rows={rows}
            {...props}
          />
        ) : (
          <InputText
            id={id}
            label={label}
            placeholder={placeholder}
            {...props}
          />
        )
      }
    />
  );
};

PartyTextField.propTypes = {
  control: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  prefix: PropTypes.oneOf(["issuer", "recipient"]).isRequired,
  field: PropTypes.oneOf(["address", "siret", "phone"]).isRequired,
  rows: PropTypes.number,
};

export default PartyTextField;
